import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=53836ff2&scoped=true"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"
import style0 from "./serviceFee.vue?vue&type=style&index=0&id=53836ff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53836ff2",
  null
  
)

export default component.exports